// extracted by mini-css-extract-plugin
export default {"l_ConfrimBtnContainer_main":"ConfrimBtnContainer_l_ConfrimBtnContainer_main__FYPO9"};